<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-2">
                {{year}} © Transshipment.
            </div>
            <div class="col-sm-10">
                <div class="row">
                    <div class="col-sm-2">
                    </div>
                    <div class="col-sm-2">
                        <div class="text-sm-end d-none d-sm-block cursor-pointer" [routerLink]="['/account/privacyPolicies']">
                            Privacy Policies 
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="text-sm-end d-none d-sm-block cursor-pointer" [routerLink]="['/account/refundPolicies']">
                            Refund Policies 
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="text-sm-end d-none d-sm-block cursor-pointer" [routerLink]="['/account/termsOfUse']">
                            Terms Of Use 
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="text-sm-end d-none d-sm-block cursor-pointer" [routerLink]="['/account/paymentPolicies']">
                            Payment Policies 
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="text-sm-end d-none d-sm-block cursor-pointer" [routerLink]="['/account/cookiePolicies']">
                            Cookie Policy
                        </div>
                    </div>
                    <!-- <div class="col-sm-5">
                        <div class="text-sm-end d-none d-sm-block">
                            Designed & Developed with <i class="fa fa-heart"></i> by Team Transshipment
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</footer>
